import {Request} from './Request';

export class RemoteStartTransactionRequest implements Request {
    private connectorId: number;
    private idTag: string;
    private chargingProfileId: number;
    chargePointSelectList: string[];

    constructor(chargePointSelectList?: string[], connectorId?: number, idTag?: string, chargingProfileId?: number) {
        this.connectorId = connectorId;
        this.idTag = idTag;
        this.chargingProfileId = chargingProfileId;
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `RemoteStartTransactionRequest (connectorId: ${this.connectorId},
        idTag: ${this.idTag}, chargingProfileId: ${this.chargingProfileId}, chargePointSelectList: ${this.chargePointSelectList})`;
    }


    get connector_id(): number {
        return this.connectorId;
    }

    set connector_id(value: number) {
        this.connectorId = value;
    }

    get id_tag(): string {
        return this.idTag;
    }

    set id_tag(value: string) {
        this.idTag = value;
    }

    get charging_profile_id(): number {
        return this.chargingProfileId;
    }

    set charging_profile_id(value: number) {
        this.chargingProfileId = value;
    }
}
